import { Dispatch, SetStateAction } from 'react';
import {
  FlexBetween,
  FlexJustifyCenter,
  HubLengthMessage
} from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { AnimatedItem } from '../../../components/animation/AnimatedItem';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { USDT, formatUSD } from '../../../helpers/helperFunctions';
import { Button } from '../../../styles/GlobalComponents';
import { InvoiceHeader, Invoices, InvoicesMobile } from '../AccountingStyled';

interface InvoicesPageType {
  invoices: any;
  setLastWeekStartDate: Dispatch<SetStateAction<number | null>>;
  countInvoices: number;
  setCountInvoices: Dispatch<SetStateAction<number>>;
}

export const InvoicesPage = ({
  invoices,
  setLastWeekStartDate,
  countInvoices,
  setCountInvoices
}: InvoicesPageType) => {
  const { t } = useTranslation('accounting');

  return (
    <AnimatedTab key={'InvoicesPage'}>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '20%' }}>{t('date')}</div>
          <div style={{ width: '20%' }}>{t('invoice_id')}</div>
          <div style={{ width: '20%' }}>{t('amount')}</div>
          <div style={{ width: '20%' }}>{t('status')}</div>
          <div
            style={{
              width: '20%',
              textAlign: 'right'
            }}>
            {t('invoice')}
          </div>
        </InvoiceHeader>
      </Desktop>

      {invoices?.length === 0 ? (
        <HubLengthMessage>{t('no_invoices')}</HubLengthMessage>
      ) : (
        invoices?.map((inv: any, i: number) => {
          return (
            <AnimatedItem index={i} key={i}>
              <Desktop>
                <Invoices>
                  <div style={{ width: '20%' }}>
                    {moment.utc(inv?.weekStartDate).format('DD/MM/YY')}
                    {' - '}
                    {moment.utc(inv?.weekEndDate).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '20%' }}>#{inv.id}</div>
                  <div style={{ width: '20%' }}>
                    <span>
                      {formatUSD(inv.amount)} {USDT}
                    </span>
                  </div>
                  <div style={{ width: '20%' }}>
                    {inv.amount !== 0
                      ? inv.isPaid
                        ? t('paid')
                        : t('processing')
                      : '/'}
                  </div>
                  <div
                    style={{
                      width: '20%',
                      textAlign: 'right'
                    }}>
                    {inv.amount === 0 && t('no_report')}
                  </div>
                </Invoices>
              </Desktop>
              <Mobile>
                <InvoicesMobile>
                  <FlexBetween>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px'
                      }}>
                      #{inv.id}
                    </div>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px',
                        fontSize: 18
                      }}>
                      {formatUSD(inv.amount)} {USDT}
                    </div>
                  </FlexBetween>
                  <FlexBetween>
                    <div>
                      {moment.utc(inv?.weekStartDate).format('DD/MM/YY')}
                      {' - '}
                      {moment.utc(inv?.weekEndDate).format('DD/MM/YY')}
                    </div>
                    <div
                      style={{
                        color: '#B5A8A8',
                        lineHeight: '18px',
                        fontSize: 12
                      }}>
                      {inv.amount !== 0
                        ? inv.isPaid
                          ? t('paid')
                          : t('processing')
                        : '/'}
                    </div>
                  </FlexBetween>
                </InvoicesMobile>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}

      {invoices?.length >= 50 && invoices?.length === countInvoices && (
        <FlexJustifyCenter>
          <Button
            w='200px'
            mt='10'
            mb='20'
            onClick={() => {
              setCountInvoices((count) => count + 50);
              setLastWeekStartDate(invoices[invoices?.length - 1]?.weekEndDate);
            }}>
            {t('show_more')}
          </Button>
        </FlexJustifyCenter>
      )}
    </AnimatedTab>
  );
};
